<template>
	<b-modal
		hide-footer
		ref="modal-view"
		size="lg"
		:title="modelId > 0 ? 'Edición de usuario' : 'Nuevo usuario'"
	>
		<b-overlay :show="loading" no-wrap></b-overlay>
		<b-form @submit="onSubmit">
			<FormGroupBox title="Datos de usuario">
				<b-form-row>
					<b-form-group :disabled="unableEdit" class="col-6" label="Nombres">
						<b-form-input type="text" size="sm" v-model="modelInfo.firstName" required/>
					</b-form-group>
					<b-form-group :disabled="unableEdit" class="col-6" label="Apellidos">
						<b-form-input type="text" size="sm" v-model="modelInfo.lastName" required/>
					</b-form-group>
				</b-form-row>
				<b-form-row>
					<b-form-group :disabled="unableEdit" class="col-6" label="Correo electronico">
						<b-form-input type="email" size="sm" v-model="modelInfo.email" required/>
					</b-form-group>
					<b-form-group :disabled="unableEdit" class="col-6" label="Telefono">
						<b-form-input type="text" size="sm" v-model="modelInfo.phone"/>
					</b-form-group>
				</b-form-row>
				<b-form-row>
					<b-form-group :disabled="unableEdit" class="col-4" label="Idioma">
						<b-form-select size="sm" v-model="modelInfo.lang" :options="$root.auxVars.langOpts"></b-form-select>
					</b-form-group>
					<b-form-group :disabled="unableEdit" class="col-4" label="Perfil">
						<b-form-select size="sm" v-model="modelInfo.profileId" :options="profileOpts"></b-form-select>
					</b-form-group>
					<b-form-group :disabled="unableEdit" class="col-4" label="Estado">
						<b-form-select size="sm" v-model="modelInfo.status" :options="statusOptions"></b-form-select>
					</b-form-group>
				</b-form-row>

				<b-form-row :class="sassType === 'core' && modelInfo.profileId == 1 ? 'd-none' : 'd-flex'">
					<b-col cols="6">
						<b-form-group label="Proveedor(es) sasignado(s)">
							<multiselect
								:disabled="unableEdit"
								v-model="modelInfo.sass.suppliers"
								:options="suppliersOpts"
								group-label="group"
								group-values="options"
								group-select
								multiple
								label="text"
								track-by="value"
								placeholder="Todos"
								ref="multiselectSuppliers"
								:option-height="10"
								required
								taggable
							/>
						</b-form-group>
					</b-col>
					<b-col cols="6">
						<b-form-group label="Punto de venta sasignado(s)">
							<multiselect
								:disabled="unableEdit"
								v-model="modelInfo.sass.pointOfSales"
								:options="pointOfSalesOpts"
								group-label="group"
								group-values="options"
								group-select
								multiple
								label="text"
								track-by="value"
								ref="multiselectPointOfSales"
								placeholder="Todos"
								:option-height="10"
								taggable
							/>
						</b-form-group>
					</b-col>
				</b-form-row>
			</FormGroupBox>
			<hr>
			<div class="text-right">
				<b-button :disabled="unableEdit" variant="primary" type="submit">{{ modelId > 0 ? 'Actualizar' : 'Guardar' }}</b-button>
			</div>
		</b-form>
	</b-modal>
</template>

<script>
import FormGroupBox from '../../helpers/FormGroupBox.vue'
import Multiselect from 'vue-multiselect'

export default {
	props: {
		unableEdit: Boolean,
		successCallback: {
			type: Function,
			required: false,
			default: () => {
			}
		}
	},
	components: {FormGroupBox, Multiselect},
	data() {
		let defaultModelInfo = {
			id: -1,
			firstName: '',
			lastName: '',
			email: '',
			phone: '',
			sass: {
				suppliers: [],
				pointOfSales: [],
			},
			status: 'active',
			app: 'core',
			profileId: 4,
		}
		return {
			modelId: -1,
			modelInfo: {...defaultModelInfo},
			defaultModelInfo: {...defaultModelInfo},
			loading: true,
			sassType: 'core',
			appOptions: [
				{value: 'core', text: 'Shuttle Central Admin'},
				{value: 'suppliers', text: 'Suppliers App'},
			],
			statusOptions: [
				{value: 'active', text: 'Activo'},
				{value: 'inactive', text: 'Inactivo'}
			],
		}
	},
	computed: {
		profileOpts() {
			return  this.$root.auxVars.profilesOpts;
		},
		suppliersOpts() {
			return [{group:'SELECT ALL', options: this.$root.auxVars.suppliersOpts}]
		},
		pointOfSalesOpts() {
			return [{group:'SELECT ALL', options: this.$root.auxVars.pointOfSalesOpts}]
		}
	},
	methods: {
		onSubmit(event) {
			event.preventDefault();
			if (this.$listeners.submit) {
				this.$listeners.submit(event);
				return;
			}
			this.loading = true;
			let rParams = {
				url: this.modelId > 0 ? `/users/${this.modelId}` : '/users',
				method: this.modelId > 0 ? 'put' : 'post',
			}

			this.modelInfo['sassType'] = this.sassType
			// this.modelInfo['sass'] = this.sassType === 'core' ? null : this.modelInfo['sass']
			rParams['data'] = this.modelInfo
			this.$root.api.request(rParams).then((res) => {
				this.$root.showAlert(rParams.method == 'post' ? 'Usuario agregado con éxito' : 'Usuario actualizado con éxito')
				if (res.data.id) this.loadModel(res.data.id, this.sassType)
				this.successCallback(res)
			}).catch(this.$root.handleRequestError)
			.then(() => {
				this.loading = false;
			});
		},
		loadModel(id, type) {
			this.modelId = id
			this.$refs['modal-view'].show()
			this.sassType = type
			this.fetchModel()
		},
		setApp(app) {
			this.modelInfo.app = app
		},
		fetchModel() {
			if (this.modelId > 0) {
				this.loading = true;
				this.$root.api
					.get(`/users/${this.modelId}`)
					.then(res => {
						this.modelInfo = { ...res.data };
						this.loading = false;

						const suppliers = res.data.sass.suppliers || []
						const pointSales = res.data.sass.pointOfSales || []

						// push suppliers opts
						if (suppliers.length > 0) {
							const aux = [];
							suppliers.map(item => {
								const option = this.$root.auxVars.suppliersOpts.find(
									({value}) => value === item.id
								);

								if (option)
									aux.push(option);
							});
							this.$refs.multiselectSuppliers.$emit("input", aux);
						}

						// push pos opts
						if (pointSales.length > 0) {
							const aux2 = []
							pointSales.map(item => {
								const option = this.$root.auxVars.pointOfSalesOpts.find(
									({value}) => value === item.id
								);

								if (option)
									aux2.push(option);
							});
							this.$refs.multiselectPointOfSales.$emit("input", aux2);
						}
					})
					.catch(this.$root.handleRequestError);
			} else {
				this.modelInfo = { ...this.defaultModelInfo };
				this.loading = false;
			}
		},
	},
	mounted() {
		console.log('mounted single')
		this.$root.auxVars.loadResourcesOpts({vm: this, resourceNames: ['suppliersOpts', 'pointOfSalesOpts', 'profilesOpts']})
	}
}
</script>

<style></style>
